import { actionTypes } from '../common/constants/actionTypes';

import WelcomePageHeroBanner from '../api/welcomePageHeroBannerEntity';
import WelcomePageHighlightBlock from '../api/welcomePageHighlightBlockEntity';

export const welcomePageContentReducer = (state: any, action: any) => {
  switch (action.type) {
      case actionTypes.FETCH_WELCOME_PAGE_HERO_BANNER_COMPLETED:
        const resultObjectClicked = handleFetchWelcomePageHeroBannerCompleted(state, action.payload);
        return resultObjectClicked;
      case actionTypes.FETCH_WELCOME_PAGE_HIGHLIGHT_MAIN_ITEMS_COMPLETED:
        const resultMainHiglightItems = handleFetchWelcomePageHighlightMainBlockCompleted(state, action.payload);
        return resultMainHiglightItems;
      case actionTypes.FETCH_WELCOME_PAGE_HIGHLIGHT_SUB_MAIN_ITEMS_COMPLETED:
        const resultSubMainHiglightItems = handleFetchWelcomePageSubHighlightMainBlockCompleted(state, action.payload);
        return resultSubMainHiglightItems;
      case actionTypes.FETCH_WELCOME_PAGE_NEWS_ITEMS_COMPLETED:
        const resultNewsItems = handleFetchWelcomePageNewsItemsCompleted(state, action.payload);
        return resultNewsItems;
  }

  if (state) {
    return state;
  }

  return { heroBanner: new WelcomePageHeroBanner(), mainHighlightItems: [], subMainHighlightItems: [], newsItems: []  };
};

const handleFetchWelcomePageHeroBannerCompleted: (state: any, payload: WelcomePageHeroBanner) => any =
function handleItems(state: any, payload: WelcomePageHeroBanner): any {
  return {
    heroBanner: payload,
    mainHighlightItems: state.mainHighlightItems,
    newsItems: state.newsItems,
    subMainHighlightItems: state.subMainHighlightItems,
  }
};

const handleFetchWelcomePageHighlightMainBlockCompleted: (state: any, payload: any) => any =
function handleItems(state: any, payload: WelcomePageHighlightBlock[]): any {
  return {
    heroBanner: state.heroBanner,
    mainHighlightItems: payload,
    newsItems: state.newsItems,
    subMainHighlightItems: state.subMainHighlightItems
  }
};

const handleFetchWelcomePageSubHighlightMainBlockCompleted: (state: any, payload: any) => any =
function handleItems(state: any, payload: WelcomePageHighlightBlock[]): any {
  return {
    heroBanner: state.heroBanner,
    mainHighlightItems: state.mainHighlightItems,
    newsItems: state.newsItems,
    subMainHighlightItems: payload
  }
};

const handleFetchWelcomePageNewsItemsCompleted: (state: any, payload: any) => any =
function handleItems(state: any, payload: WelcomePageHighlightBlock[]): any {
  return {
    heroBanner: state.heroBanner,
    mainHighlightItems: state.mainHighlightItems,
    newsItems: payload,
    subMainHighlightItems: state.subMainHighlightItems
  }
};


// WEBPACK FOOTER //
// ./src/reducers/welcomePageContent.ts